import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { debounceTime } from 'rxjs/operators';
declare var dataLayer;
@Directive({
    selector: '[appDebounceClick]',
    standalone: false
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 0;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  @Input() load: Boolean;
  @Input() analyticsModel: {
    event: string,
    category: string,
    action: string,
    label: string,
    EstadoSubsidio?: string
  }
  @Input() event: string;
  @Input() label: string;
  @Input() action: string;
  @Input() category: string;

  constructor(public viewContainerRef: ViewContainerRef) { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTime),

    ).subscribe((e: any) => {

      this.debounceClick.emit(e)
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(e) {

    if (!this.load ) {
      if (this.analyticsModel) {
        let data = { ...this.analyticsModel }
        if (this.event) {
          data.event = this.event + data.event;
        }
        if (this.action) {
          data.action = this.action
        }
        if (this.label) {
          data.label = this.label
        }
        if (this.category) {
          data.category = this.category
        }
        dataLayer.push(data);
      } else {
        let target = e.target.id && e.target.title ? e.target : e.currentTarget;
        let categoy = target.id.split("_")[0] ? target.id.split("_")[0] : '';
        let idAttr = target.id.split("_")[1] ? target.id.split("_")[1] : '';
        var title = target.title;

        let temp = target.id.split("_")[2] ? target.id.split("_")[2] : '';
        if (temp) {
          if (target.id.split("_")[2].split(":").length > 0) {
            let namePropiedad = target.id.split("_")[2].split(":")[0] ? target.id.split("_")[2].split(":")[0] : '';
            let value = target.id.split("_")[2].split(":")[1] ? target.id.split("_")[2].split(":")[1] : '';
            dataLayer.push({ 'event': 'ga_event', 'category': categoy, 'action': idAttr, 'label': title, [namePropiedad]: value });

          } else {
            let value = target.id.split(":")[0] ? target.id.split(":")[0] : '';
            dataLayer.push({ 'event': 'ga_event', 'category': categoy, 'action': idAttr, 'label': title, 'value': value });
          }

        } else {
          dataLayer.push({ 'event': 'ga_event', 'category': categoy, 'action': idAttr, 'label': title });
        }
      }
    }
    // event.preventDefault();
    // event.stopPropagation()
    this.clicks.next(event);
  }
  @HostListener('load', ['$event'])
  onPageLoad(event: Event) {
    if (this.load && this.viewContainerRef) {
      let data = { ...this.analyticsModel }
      if (this.event) {
        data.event = this.event + data.event;
      }
      if (this.action) {
        data.action = this.action
      }
      if (this.label) {
        data.label = this.label
      }
      if (this.category) {
        data.category = this.category
      }
      dataLayer.push(data);
    }

    // event.preventDefault();
    // event.stopPropagation()
    this.clicks.next(event);
  }

}